import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import { FeatureNeededComponent } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.component';
import * as i0 from "@angular/core";
import * as i1 from "EntitlementsApp/ts/features/feature-needed/feature.service";
export class InfoFieldSelectorModalDirective {
    constructor(featureService) {
        this.featureService = featureService;
        this.selectedInfoFields = [];
        this.modalOpen = false;
    }
    openModal() { }
    closeModal() { }
    resetModal() {
        this.selectedInfoFields = [];
    }
}
InfoFieldSelectorModalDirective.ɵfac = function InfoFieldSelectorModalDirective_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || InfoFieldSelectorModalDirective)(i0.ɵɵdirectiveInject(i1.FeatureService)); };
InfoFieldSelectorModalDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: InfoFieldSelectorModalDirective, viewQuery: function InfoFieldSelectorModalDirective_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(FeatureNeededComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.featureNeededModal = _t.first);
    } }, inputs: { infoType: "infoType" } });
